/*SET*/

//Set Layer Value
export const set_layer_value = (key, value) => (dispatch) => {
  dispatch({
    type: "set_layer_value",
    payload: { key, value },
  });
};